import Grid from '@mui/material/Unstable_Grid2/Grid2'
import ProcuraVisitante from './ProcuraVisitante/ProcuraVisitante'
import VisitanteInfo from './VisitanteInfo/VisitanteInfo'
import LiberarAcessoVisitante from './LiberarAcessoVisitante/LiberarAcessoVisitante'
import VisitantesSelecionados from './VisitantesSelecionados/VisitantesSelecionados'
import { useContext, useState } from 'react'
import ListaEntradas from '../../../Components/ListaEntradas/ListaEntradas'
import { VisitantesContext } from '../../../Providers/VisitantesContext/VisitantesContext'
import Autorizados from './Autorizados/Autorizados'

const VisitantesTab = () => {
    const { liberarAcessoVisitantes, visitanteInfo } = useContext(VisitantesContext)
    const [isDisabled, setIsDisabled] = useState(true)

    const modifyDisabled = (value) => {
        setIsDisabled(value)
    }

    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>

            <ProcuraVisitante height={'7%'} />

            <VisitanteInfo height={{ xs: '50%', lg: '50%', xl: '30%' }} />

            <Grid sx={{ display: 'flex', flexDirection: 'row', height: { xs: '42%', lg: '42%', xl: '62%' }, width: '100%' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '80%', borderRight: '1px solid white' }}>

                    {/* <VisitantesPreAutorizados/> */}

                    <Grid container xs={12} sx={{
                        flexDirection: 'row',
                        height: '100%',
                        padding: '5px 5px'
                    }}>
                        <LiberarAcessoVisitante
                            modifyDisabled={modifyDisabled}
                        />
                        {visitanteInfo
                            ? <Autorizados/>
                            : (
                                <Grid sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                                    <Grid sx={{ width: '97%' }}>
                                        <ListaEntradas
                                            callbackAbrirPorta={liberarAcessoVisitantes}
                                            isDisabled={isDisabled}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                    </Grid>
                </Grid>
                <VisitantesSelecionados modifyDisabled={modifyDisabled}/>
            </Grid>
        </Grid>
    )
}

export default VisitantesTab
